import React from 'react';
import './PolicyPageLayout.css';

const PolicyPageLayout = ({ title, sections, icon }) => {
  return (
    <div className="policy-page">
      <div className="policy-hero">
        <div className="container">
          <div className="policy-hero-content">
            {icon && <div className="policy-icon">{icon}</div>}
            <h1 className="policy-title">{title}</h1>
            <div className="policy-divider"></div>
          </div>
        </div>
      </div>

      <div className="container policy-container">
        <div className="policy-content">
          {sections.map((section, index) => (
            <div key={index} className="policy-section" style={{ '--section-index': index }}>
              <div className="policy-section-number">{String(index + 1).padStart(2, '0')}</div>
              <div className="policy-section-content">
                <h2 className="policy-section-title">{section.title}</h2>
                {section.content && (
                  <div className="policy-section-text">
                    {typeof section.content === 'string' ? (
                      <p>{section.content}</p>
                    ) : (
                      section.content
                    )}
                  </div>
                )}
                {section.list && (
                  <ul className="policy-section-list">
                    {section.list.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                )}
                {section.highlight && (
                  <div className="policy-section-highlight">
                    {section.highlight}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PolicyPageLayout;